import axios from 'axios';

const baseURL = (function () {
  const env = process.env.NODE_ENV;
  return env === 'development' ? 'https://op-api.tai.sparta.html5.qq.com' : 'https://op-api.tai.qq.com';
}());
const request = axios.create({
  baseURL: location.hostname === 'localhost' ? '/' : baseURL,
  timeout: 10000,
  withCredentials: true, // 允许携带cookie
});

// 响应拦截器
request.interceptors.response.use(
  (res) => {
    const { data } = res;
    if (data.code !== 0) {
      console.log('error: ', data.msg);
      return Promise.reject(res.data);
    }
    return data;
  },
  error => Promise.reject(error),
);

/**
 * 替换rest api中的路径参数
 * @param url - 例如 /product/:productId
 * @param params - 例如 {productId: 1234}
 */
export function replaceParamsInUrl(url, params) {
  for (const key of Object.keys(params)) {
    const val = params[key];
    url = url.replace(`:${key}`, val);
  }
  return url;
}

export default request;
